import { IRoomType } from './types';
import { ERooms } from '../../../types/rooms';

export const ROOM_TYPES: IRoomType[] = [
  {
    label: '1',
    value: ERooms.One,
  },
  {
    label: '2',
    value: ERooms.Two,
  },
  {
    label: '3',
    value: ERooms.Three,
  },
  {
    label: '4 +',
    value: ERooms.FourPlus,
  },
];
